import { useSearchParams } from "react-router-dom";
import { useAcceptCoOrganizerInviteMutation } from "../redux/features/event/event.api";
import { Actions } from "../utils/types";

export const useActionExecutor = () => {
  const [searchParams] = useSearchParams();

  const userId_: string = searchParams?.get("userId") ?? "";
  const email_: string = searchParams?.get("email") ?? "";
  const eventId_: string = searchParams?.get("eventId") ?? "";
  const action = searchParams?.get("action") as Actions;

  const [acceptInvite] = useAcceptCoOrganizerInviteMutation();

  const executeAction = async (
    userId: string = userId_,
    email: string = email_,
    eventId: string = eventId_,
  ) => {
    // Accept invite action execution
    if (action === "accept-invite") {
      await acceptInvite({
        eventId: eventId,
        payload: {
          userId: userId,
          email: email,
        },
      });
    }
  };

  return {
    executeAction,
    action,
  };
};
